import * as React from "react";
import { forwardRef } from "react";
const SvgPushRight = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={12} viewBox="0 0 20 12" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}><path d="M20 5.906L6.818 5.906M12.273.452L6.818 5.906 12.273 11.361M.909 11.361L.909.452" transform="matrix(-1 0 0 1 20 0)" /></g></svg>;
const ForwardRef = forwardRef(SvgPushRight);
export { ForwardRef as ReactComponent };